import React, { Component } from 'react';
import styled from 'styled-components';

import mediaWidth from '../../../utils/mediaWidth/mediaWidth';
import Links from '../../../utils/links';

import logo from './assets/logo.svg';

export default class Logo extends Component {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const { handleChangePage } = this.props;
        if (handleChangePage) handleChangePage(Links.MAIN);
    }

    render() {
        const { className } = this.props;

        return (
            <Root
                className={className}
                onClick={this.handleClick}
            >
                <Image src={logo} />
            </Root>
        );
    }
}

const Image = styled.img`
    width: 151px;
    height: 22px;

    ${mediaWidth.m} {
        width: 153px;
    };

    ${mediaWidth.xl} {
        width: 192px;
        height: 28px;
    };
`;

const Root = styled.div`
    position: absolute;
    top: 24px;
    left: 16px;

    cursor: pointer;

    ${mediaWidth.m} {
        top: 34px;
        left: 48px;
    };

    ${mediaWidth.l} {
        top: 32px;
        left: 64px;
    };

    ${mediaWidth.xl} {
        left: 80px;
    };
`;
